import styled from 'styled-components'

export const CurrencyLabel = styled('span')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`

export const GrayBox = styled("div")`
  margin-bottom: 20px;
  background-color: rgba(245, 245, 245, 1);
  border-radius: 6px;
  padding: 19px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.5);

  p {
    &:first-child {
      margin-top: 0px;
    }

    &:last-child {
      margin-bottom: 0px;
    }
  }
`;

export const Button = styled("button")`
  font-size: 12px;
  line-height: normal;
  color: white;
  text-decoration: none;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.Primary};
  border-radius: 4px;
  border: none;
  padding: 2px 4px;
  margin: 0px 0px 0px 4px;
`